import { purchaseOrderIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const generatePurchaseOrderPdf = {
  name: "generatePurchaseOrderPdf" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
  }),
  output: z.object({
    url: z.string(),
  }),
};
